module.exports = "/_next/static/images/mike-stallard-3986d61e0922904660c349cb540c76d8.jpg";